<template>
  <div>
    <div style="padding-top:10px;" v-if="!readFlag">
      <el-button size="small" icon="el-icon-back" @click="handleBack()">返回</el-button>
    </div>
    <el-card class="form-container" shadow="never" :style="{width:formWidth}">
      <el-form :model="form" :rules="rules" :label-width="formLabelWidth" ref="courseForm" :disabled="readFlag">

        <el-form-item label="课程编号" prop="cno">
          <el-input v-model="form.cno" placeholder="请输入课程号" clearable :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item label="课程名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入课程名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="任课教师" >
          <el-select v-model="form.tnoArr" placeholder="请选择教师" multiple clearable style="width: 100%;">
            <el-option :label="item.name" v-for="item in teacherItems" :value="item.tno" :key="item.tno">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="课程图片">
          <multi-upload v-model="form.pictureArr"></multi-upload>
        </el-form-item>   -->
        <el-form-item label="课程简介">
          <el-input :autoSize="true" v-model="form.introduction" rows=3 type="textarea" placeholder="请输入内容"></el-input>
        </el-form-item> 
        <el-form-item label="图文介绍">          
          <tinymce v-model="form.imageText"></tinymce>
        </el-form-item>                      
        <el-form-item v-if="!readFlag">
          <el-button size="small" type="primary" @click="submitForm('courseForm')">提交</el-button>
          <el-button size="small" v-if="!isEdit" @click="resetForm('courseForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { selectCourseByNo, addCourse, updateCourse } from '@/api/course'
import { selectAllTeacher } from '@/api/teacher'
import CommonUtil from "@utils/common-util"
import MultiUpload from '@/components/Upload/multiUpload'
import Tinymce from '@/components/Tinymce'
const defaultForm = {
  cno: '',
  cname: '',
  tnoArr: [],
  pictureArr: [],
  introduction: '',
  imageText:''
};
export default {
  name: "courseForm",
  components: { MultiUpload,Tinymce },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    cno:{
      type: String,
    },
    readFlag:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: Object.assign({}, defaultForm),
      rules: {
        cno: [{ required: true, message: '请输入课程号', trigger: 'blur' }],
        name: [{ required: true, message: '请填写课程名', trigger: 'blur' }],
      },
      formLabelWidth: '120px',
      formWidth:'1100px',
      teacherItems: []
    }
  },
  created() {
    this.initInfo()
  },
  methods: {
    async initInfo() {
      let teacherResp = await selectAllTeacher()     
      this.teacherItems= teacherResp.data.data    
      if (this.isEdit) {
        selectCourseByNo(this.cno).then(response => {
          let formObj = response.data.data
          let pictureArr = formObj.pictures?_.split(formObj.pictures, ','):[]
          let tnoArr = formObj.tnos ? _.split(formObj.tnos, ',') : []
      
         this.form = Object.assign(formObj,
            { tnoArr: tnoArr, pictureArr: pictureArr})
          // this.submitComplete(response, '修改成功！', callback)
        })
      } else {
        this.form = Object.assign({}, defaultForm);
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form = Object.assign({}, defaultForm);
    },
    //提交信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return
        }
        this.form['pictures'] = _.join(this.form['pictureArr'], ',')
        this.form['tnos'] = _.join(this.form['tnoArr'], ',')

       // this.form['cpno'] = null
        CommonUtil.submitForm(this.isEdit, this.form, addCourse, updateCourse, this.handleBack)
      })
    },
    handleBack() {
      this.$router.back();
    }
  }
}
</script>

<style scoped>
</style>
